import * as React from 'react';
import * as _ from 'lodash';
import { IBaseResponse } from '@nkr/models/index';
import { ICryoShipmentsPendingResponse } from '@nkr/store/nkr-lab';
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, NkrLabActionCreators } from '@nkr/store/index';
import NkrLabRow from './pending-shipment-row';
import { ICryoShipmentPending } from './cryo-shipment-pending';
import { Button, Table } from 'react-bootstrap';

interface IProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCryoPendingShipments: () => Promise<ICryoShipmentsPendingResponse>,
    markCryoShipped: (data: { xmTrackingId: number, trackingNumber: string }[]) => Promise<IBaseResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    list: ICryoShipmentPending[];
    donorAlias: string;
}

class Nkrlab extends React.Component<TProps, IState> {
    readonly state: IState = { list: [], donorAlias: '' }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Getting Pending Cryo Shipments, one moment please...").then(() => {
            this.props.getCryoPendingShipments().then(response => {
                if (response.data.success) {
                    let list = response.data.results;

                    this.setState({
                        list: list.map(item => {
                            return { ...item, trackingNumber: '' }
                        })
                    }, () => {
                        this.props.hideLoading();

                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleDonorSubmit = () => {
        let donorAlias = this.state.donorAlias;

        if (donorAlias.length > 0) {
            let url = `/nkr-lab/donor-options/${donorAlias}`;
            window.location.href = url;
        }
    }

    handleSubmit = () => {
        let list = this.state.list.filter(x => x.trackingNumber != '').map(p => {
            return { xmTrackingId: p.xmTrackingId, trackingNumber: p.trackingNumber };
        });

        this.props.showLoading("Shipping Pending Cryo Shipments, one moment please...").then(() => {
            this.props.markCryoShipped(list).then(response => {
                if (response.data.success) {
                    this.getData();
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleTrackingNumberChange = (xmTrackingId: number, trackingNumber: string) => {
        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.xmTrackingId == xmTrackingId) {
                item.trackingNumber = trackingNumber;
            }

            return item;
        });

        this.setState({ list });
    }

    handleDonorAliasChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            donorAlias: e.currentTarget.value
        });
    }

    render = () => {
        return (
            <div className='container'>
                <div className='row' style={{ marginBottom: 25 }}>
                    <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1 style={{ margin: 0 }}>NKR Lab</h1>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>
                                To search for a donor enter the alias:
                            </div>
                            <div style={{ marginRight: 5 }}>
                                <input className='form-control' type='text' value={this.state.donorAlias} onChange={this.handleDonorAliasChange} />
                            </div>
                            <div>
                                <Button bsStyle="primary" onClick={this.handleDonorSubmit} >
                                    <div>Search Donor</div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getCryoPendingShipments: () => { return dispatch(NkrLabActionCreators.getCryoShipmentsPending()); },
        markCryoShipped: (data: { xmTrackingId: number, trackingNumber: string }[]) => { return dispatch(NkrLabActionCreators.markCryoShipped(data)); },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Nkrlab)